import { useNotification } from "@expert/common-ui";
import { useCallback } from "react";

import { useAgentSdk, useLogger } from "@/sdk";

export function useMorningPaperShiftRitual() {
    const sdk = useAgentSdk();
    const logger = useLogger({ module: "MorningPaperShiftRitual" });
    const notification = useNotification();

    const startShift = useCallback(async (): Promise<void> => {
        try {
            await sdk.setAgentActivity(sdk.availableAgentActivity);
            logger.info("Morning paper: unparked expert to Available");
        } catch (err: unknown) {
            logger.error({ err }, "Morning paper: failed to unpark expert to Available");
            notification.error("Couldn't set your status to Available. Please set it manually from the status menu.");
        }
    }, [sdk, logger, notification]);

    return { startShift };
}
